module.exports = __webpack_public_path__ + "img/image_droite_section_1.2b352828.png";